/* eslint-disable @typescript-eslint/no-explicit-any */
import i18n from '@portal/i18n/config';
import { translate } from '~/services/i18n';

export const getEnumDescription = (
  value: number | string,
  enumerator: string,
  callbackText?: string
): string => {
  if (value != null) {
    const language = i18n.language || 'pt-BR';
    const translationData = i18n.getResourceBundle(language, 'translation');

    if (translationData?.ENUMERATORS?.[enumerator]) {
      const enumeratorData = translationData.ENUMERATORS[enumerator];
      const items = Object.values(enumeratorData);

      const translation = items.find((item) => {
        if (item && typeof item === 'object' && 'VALUE' in item) {
          return item.VALUE === value.toString();
        }
        return false;
      });

      if (
        translation &&
        typeof translation === 'object' &&
        'TEXT' in translation
      ) {
        return translation.TEXT as string;
      }
    }
  }

  return callbackText ? translate(callbackText) : translate('SHARED.OTHER');
};

export const isStatementDayArray = (
  transactions: any
): transactions is bank.StatementDay[] =>
  transactions &&
  transactions[0] &&
  'date' in transactions[0] &&
  'extract' in transactions[0];

/**
 * Gets the enum key (name) based on its value
 * @param value The value to look up in the enum
 * @param enumObj The enum object to search in
 * @returns The enum key as a string, or undefined if not found
 */
export function getEnumKeyByValue<T extends Record<string, any>>(
  value: any,
  enumObj: T
): string | undefined {
  const searchValue =
    typeof value === 'string' && !isNaN(Number(value)) ? Number(value) : value;

  const entries = Object.entries(enumObj).filter(([key]) => isNaN(Number(key)));

  const entry = entries.find(([, val]) => val === searchValue);

  return entry ? entry[0] : undefined;
}
